var ExchangeURL;
export function ExchangeWindowopenorFocus(URL, accessmode) {
  if (URL !== null && URL !== undefined) {
    if (!ExchangeURL || ExchangeURL.closed) {
      ExchangeURL = window.open(URL, accessmode === "app" ? '_self' : '_blank');
      if (ExchangeURL === null) {
        return false;
      }
    }
    else {
      ExchangeURL.focus();
      return true;
    }
    return true;
  }
  return false;
}

export function ExchangeWindowClose() {
  if (ExchangeURL != null) {
    ExchangeURL.close();
  }
}